<img [src]="selectedImage?.url || 'assets/logos/link.svg'" [class.ph]="!selectedImage?.url" />

@if ((product?.images?.length ?? 0) > 1) {
  <div class="thumbnails">
    <img
      *ngFor="let img of product?.images; let i = index"
      [src]="selectedImage?.url"
      (mouseenter)="selectedIndex = i"
      [class.selected]="selectedIndex === i"
    />
  </div>
}
